import { createContext, useContext, useState, useCallback } from "react";
import { API_BASE } from "../config/api";

const SCHOOL_SYSTEM_URL = process.env.REACT_APP_SCHOOL_SYSTEM_URL;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("mcct_user")); } catch { return null; }
  });
  const [token, setToken] = useState(() => localStorage.getItem("mcct_token"));

  const login = useCallback(async (email, password) => {
    const res = await fetch(`${API_BASE}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "Login failed");

    localStorage.setItem("mcct_token", data.token);
    localStorage.setItem("mcct_user", JSON.stringify(data.user));
    setToken(data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("mcct_token");
    localStorage.removeItem("mcct_user");
    setToken(null);
    setUser(null);
  }, []);

  const authFetch = useCallback((url, opts = {}) =>
    fetch(`${API_BASE}${url}`, {
      ...opts,
      headers: { ...(opts.headers || {}), Authorization: `Bearer ${token}` },
    }), [token]);

  return (
    <AuthContext.Provider value={{ user, token, login, logout, authFetch, SCHOOL_SYSTEM_URL }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
